export default (currency: string, locales = 'en-US') => new Intl.NumberFormat(locales, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
});
